import { setWithExpiry, getWithExpiry } from '../../localStorage'

const state = {
  emailForSignIn: null
}

const getters = {
  emailForSignIn: (state) => {
    if (state.emailForSignIn === null) {
      // get from local storage
      state.emailForSignIn = getWithExpiry('emailForSignIn') 
    }
    return state.emailForSignIn
  }
}

const mutations = {
  setEmailForSignIn(state, newValue) {
    state.emailForSignIn = newValue
    if (newValue == null) {
      localStorage.removeItem('emailForSignIn')
    } else {
      setWithExpiry('emailForSignIn', newValue, 6*60*60*1000)
    }
  }
}

const actions = {
  setEmailForSignIn({ commit }, email) {
    commit('setEmailForSignIn', email)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}